import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Globe, ArrowSquareOut, Golf } from '@phosphor-icons/react';

const ORG_LOGOS = {
  pga: { abbr: 'PGA', color: '#003366' },
  lpga: { abbr: 'LPGA', color: '#c2185b' },
  dp: { abbr: 'DP', color: '#1a237e' },
  asian: { abbr: 'AT', color: '#e65100' },
  golf_ca: { abbr: 'GC', color: '#d32f2f' },
  golf_au: { abbr: 'GA', color: '#1B5E20' },
  igf: { abbr: 'IGF', color: '#01579b' },
  ngf: { abbr: 'NGF', color: '#4a148c' },
};

export default function GolfNewsWidget() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/golf/organizations')
      .then(({ data }) => setOrgs(data.organizations))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="widget-card animate-pulse" data-testid="golf-news-widget-loading">
        <div className="h-4 bg-muted rounded w-32 mb-4" />
        {[...Array(4)].map((_, i) => <div key={i} className="h-10 bg-muted rounded mb-2" />)}
      </div>
    );
  }

  return (
    <div className="widget-card" data-testid="golf-news-widget">
      <div className="flex items-center gap-2 mb-4">
        <Golf size={16} weight="bold" className="text-primary" />
        <p className="text-[10px] text-muted-foreground uppercase tracking-[0.15em] font-sans font-semibold">
          Golf Organizations
        </p>
      </div>

      <div className="space-y-1.5" data-testid="golf-orgs-list">
        {orgs.map(org => {
          const logo = ORG_LOGOS[org.id] || { abbr: '??', color: '#666' };
          return (
            <a
              key={org.id}
              href={org.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-2.5 py-2 rounded-sm hover:bg-muted/50 transition-colors duration-200 group"
              data-testid={`golf-org-${org.id}`}
            >
              <div
                className="w-8 h-8 rounded-sm flex items-center justify-center text-white text-[10px] font-bold font-sans flex-shrink-0"
                style={{ backgroundColor: logo.color }}
              >
                {logo.abbr}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-sans font-medium text-foreground truncate group-hover:text-primary transition-colors">
                  {org.name}
                </p>
                <p className="text-[10px] text-muted-foreground font-sans">{org.region}</p>
              </div>
              <ArrowSquareOut size={12} className="text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
            </a>
          );
        })}
      </div>
    </div>
  );
}
